import {createAction} from '@reduxjs/toolkit';

export const savePhotos = createAction('SAVE_PHOTOS');
/**
 * Payload is the photo limit
 */
export const launchCameraRoll = createAction<number>('LAUNCH_CAMERA_ROLL');
